import { Flex, Link } from '@opendoor/bricks/core';

export type Crumb = {
  name: string;
  href: string;
};

const crumbsToJsonSchema = (crumbs: Array<Crumb>) => {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => {
      return {
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@id': c.href,
          name: c.name,
        },
      };
    }),
  });
};

const Breadcrumbs: React.FC<{ crumbs: Array<Crumb> }> = ({ crumbs }) => {
  if (crumbs.length < 1) {
    return null;
  }
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: crumbsToJsonSchema(crumbs) }}
      ></script>
      <Flex display="inline-flex" flexWrap="wrap">
        {crumbs.map((c, i) => {
          return (
            <Link
              key={i}
              fontSize={['s00', null, 's0']}
              color="neutrals90"
              variant={i < crumbs.length - 1 ? 'nav' : 'inline-primary'}
              textDecoration="none"
              aria-label={c.name}
              analyticsName="cosmos-pdp-breadcrumb"
              href={c.href}
            >
              {c.name}
            </Link>
          );
        })}
      </Flex>
    </>
  );
};

export default Breadcrumbs;
